import React from 'react';
import { Box, Grid, Typography,Container} from '@mui/material';
import { Link} from 'react-router-dom';
import imgUrl from '../assets/images/imgUrl';

export default function Footer() {
  return (
    <Box sx={{ backgroundColor: '#A0CF76', color: '#000', pt: 4 }} mt={5} className="footerSection">
     <>
      <Grid container spacing={0} justifyContent="center" alignItems="center" px={4}>
        {/* Left: Contact Info */}  
        
        <Grid size={{xs:12 , md:1 , sm:0}}></Grid>
        <Grid size={{xs:12 , md:3 , sm:5}}>
          <Typography variant="body2" fontWeight="bold" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>I Am Peacekeeper Movement</Typography>
          <Typography variant="body2" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>Jupiter Events LLC</Typography>
          <Typography variant="body2" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>Youssef Zahra Building,</Typography>
          <Typography variant="body2" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>B10343 Office</Typography>
          <Typography variant="body2" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>Al Quoz 3, Hadaeq Mohammed Bin Rashid</Typography>
          <Typography variant="body2" sx={{ fontFamily: 'DIN Pro Regular, sans-serif' }}>Dubai, UAE</Typography>
        </Grid>

        {/* Center: Logo & Social Icons */}
        <Grid size={{xs:12 , md:4 , sm:3}} textAlign="center">
          {/* <Box component="img"
               src="/logo.png" // Update this path
               alt="Peacekeeper Logo"
               sx={{ height: 60, mb: 2 }}
          /> */}
            <div className='footerLogos'>
          <img src={imgUrl.peaceMovImg} className='w-100 max-width-100px footerMovImg'></img>
           
          </div>
        </Grid>

        {/* Right: Circular Map Image */}
        <Grid size={{xs:12 , md:3 , sm:4}} textAlign="center">
            {/* <img src={imgUrl.mapImg} className='footerMap'></img> */}

            <Link to="https://duretechnologies.com" target='_blank' className='cursor-pointer'>
                    <img src={imgUrl.dureLogo} className='w-100 dureLogoImg'></img>
                    </Link>
             
          <Box className="d-flex-align-center-justify-center gap-10px mt-20px">
            <Link to="https://www.facebook.com/IAmPeacekeeperMovement" target='_blank' className='cursor-pointer'>
            <img src={imgUrl.fbIcon} className='max-width-100px'></img>
            </Link>
            <Link to="https://x.com/IAmPeacekeeperM" target='_blank' className='cursor-pointer'>
            <img src={imgUrl.xIcon} className='max-width-100px'></img>
            </Link>
            <Link to="https://www.instagram.com/iampeacekeepermovement" target='_blank' className='cursor-pointer'>
           <img src={imgUrl.instaIcon} className='max-width-100px'></img>
           </Link>
           <Link to="https://www.threads.com/@iampeacekeepermovement" target='_blank' className='cursor-pointer'>
           <img src={imgUrl.threadsIcon} className='max-width-100px' style={{borderRadius: "4px"}}></img>
           </Link>
           <Link to="https://www.youtube.com/@IAMPEACEKEEPER" target='_blank' className='cursor-pointer'>
            <img src={imgUrl.utubeIcon} className='max-width-100px'></img>
            </Link>
             <Link to="https://www.linkedin.com/company/iampeacekeepermovement" target='_blank' className='cursor-pointer'>
            <img src={imgUrl.linkedInIcon} className='max-width-100px'></img>
            </Link>
             <Link to="mailto:peace@i-am-peacekeeper.com" className='cursor-pointer'>
            <img src={imgUrl.mailIcon} className='max-width-100px'></img>
            </Link>
          </Box>
        </Grid>

         <Grid size={{xs:12 , md:1,sm:0}}></Grid>
        
      </Grid>
     </>  

      {/* Bottom Bar */}
      <Box sx={{ backgroundColor: '#005b6d', color: '#fff', mt: 4, py: 1, textAlign: 'center', fontSize:"20px" }}>
        <Typography variant="body2" className='copyRightText' sx={{ fontFamily: 'Modernsans !important' }}>Copyright© Jupiter Events LLC</Typography>
      </Box>
    </Box>
  );
}
